// import { fetchSchema, updateFileAttribute } from "../services/api";
// import { ensureSessionForUser } from "./sessionManager";
// import { saveFileInfo } from "./storage";

// export async function detectSchemaFromRows(file, rows = [], userId) {
//   if (!file) return { schema: null, meta: null };

//   let schema = { columns: [], rowsCount: rows.length };
//   let meta = null;

//   try {
//     const sessionId = await ensureSessionForUser(userId);

//     let apiResponse = await fetchSchema(file, userId, sessionId);

//     // If file already exists, call updateFileAttribute
//     if (!apiResponse?.success?.[0]?.Data_Types) {
//       apiResponse = await updateFileAttribute(file, userId, sessionId);
//     }

//     const success = apiResponse?.success?.[0];
//     if (success) {
//       schema = {
//         columns: Object.entries(success.Data_Types).map(([name, type]) => ({
//           name,
//           detectedType: type.toLowerCase(),
//           sampleValues: [],
//         })),
//         rowsCount: rows.length,
//       };

//       meta = {
//         fileName: file.name,
//         userId,
//         sessionId,
//         userSessionFileId: success.User_Session_File_Id,
//       };

//       // Save file info
//       await saveFileInfo(meta);
//       return { schema, meta };
//     }
//   }  catch (err) {
//     // console.error("🚨 detectSchemaFromRows failed:", err?.message || err);
//  return { status: "error", schema: null, meta: null, error: err?.message || "Unknown error" };

//   }

//   return { schema: null, meta: null };
// }

import { fetchSchema, updateFileAttribute } from "../services/api";
import { ensureSessionForUser } from "./sessionManager";
import { saveFileInfo } from "./storage";

export async function detectSchemaFromRows(file, rows = [], userId) {
  if (!file) {
    return {
      status: "error",
      schema: null,
      meta: null,
      error: "No file provided",
    };
  }

  let schema = { columns: [], rowsCount: rows.length };
  let meta = null;

  try {
    const sessionId = await ensureSessionForUser(userId);
    let apiResponse = await fetchSchema(file, userId, sessionId);

    // If schema not found, try updating attributes
    if (!apiResponse?.success?.[0]?.Data_Types) {
      apiResponse = await updateFileAttribute(file, userId, sessionId);
    }

    const success = apiResponse?.success?.[0];

    // ✅ Schema successfully detected
    if (success && success.Data_Types) {
      schema = {
        columns: Object.entries(success.Data_Types).map(([name, type]) => ({
          name,
          detectedType: type.toLowerCase(),
          sampleValues: [],
        })),
        rowsCount: rows.length,
      };

      meta = {
        fileName: file.name,
        userId,
        sessionId,
        userSessionFileId: success.User_Session_File_Id,
      };

      await saveFileInfo(meta);

      return { status: "success", schema, meta };
    }

    // ❌ If success object missing or empty
    return {
      status: "no_schema",
      schema: null,
      meta: null,
      error: "No schema detected from server response",
    };
  } catch (err) {
    // console.error("🚨 detectSchemaFromRows failed:", err);
    return {
      status: "error",
      schema: null,
      meta: null,
      error: err?.message || "Unknown error occurred while detecting schema",
    };
  }
}
